import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PostalCodeForm from '../containers/PostalCodeFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class PostalCodeEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PostalCodeEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('postal_code_route_edit')} />
          <PostalCodeForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PostalCodeEditScreen;

Logger.log('silly', `PostalCodeEditScreen loaded.`);
